import { HolUser } from '../../common/models/hol-user.model';
import { EclCrisis } from '../../ecl/models/ecl-crisis';
import { EclSummary } from '../../ecl/models/ecl-summary';

export abstract class OclGroup<T> {
  objectId?: string;
  title?: string;
  createdBy?: HolUser;
  createdAt?: Date;
  items: T[];
  displayInGroupViewStatus: string;
  summary: EclSummary = null;

  crisis: any;
  protected constructor(parseObject?: Parse.Object) {
    if (!parseObject) {
      return;
    }
    this.objectId = parseObject.id;
    this.title = parseObject.get('title');
    if (parseObject.get('createdBy')) {
      this.createdBy = new HolUser(parseObject.get('createdBy'));
    }
    this.createdAt = parseObject.get('createdAt');
  }

  protected abstract newItem(parseObject?: Parse.Object): T;
}
